import React from 'react';
import { Route } from 'react-router-dom';
import { PageTitleHeader } from '../../../shared/headers/PageTitleHeader';
import {
    isComparisonEnabled,
    isSimulationEnabled
} from '../../../shared/feature-flags';
import { inSimulation } from './common/SimulationLayout';
import RunsListContainer from './runs/RunsListContainer';
import NewRunContainer from './runs/NewRunContainer';
import RunDetailContainer from './runs/RunDetailContainer';
import WorkspacesContainer from './workspaces/WorkspacesContainer';
import TestChangeContainer from './comparison/TestChangeContainer';
import ComparisonContainer from './comparison/ComparisonContainer';
import { SimulationPath } from './simulation.paths';

/* The simulation screens, each inside the frame of the simulation (its sections, and who may see it). */
const SimulationRuns = inSimulation(RunsListContainer);
const SimulationNewRun = inSimulation(NewRunContainer);
const SimulationRunDetail = inSimulation(RunDetailContainer);
const SimulationWorkspaces = inSimulation(WorkspacesContainer);
const SimulationTestChange = inSimulation(TestChangeContainer);
const SimulationComparison = inSimulation(ComparisonContainer);

const runRoutes = () => [
    <Route
        exact
        hideJurisdictionSelect
        path={SimulationPath.RUNS}
        component={SimulationRuns}
        title={() => <PageTitleHeader title={'Simulation'} subtitle={'Runs'} />}
    />,
    <Route
        exact
        hideJurisdictionSelect
        path={SimulationPath.WORKSPACES}
        component={SimulationWorkspaces}
        title={() => (
            <PageTitleHeader title={'Simulation'} subtitle={'Sandboxes'} />
        )}
    />,
    <Route
        exact
        hideJurisdictionSelect
        path={SimulationPath.NEW_RUN}
        component={SimulationNewRun}
        title={() => (
            <PageTitleHeader title={'Simulation'} subtitle={'New run'} />
        )}
    />
];

/* "Test a change" has to come before the route of a run, which would take it for the id of one. */
const comparisonRoutes = () => [
    <Route
        exact
        hideJurisdictionSelect
        path={SimulationPath.TEST_CHANGE}
        component={SimulationTestChange}
        title={() => (
            <PageTitleHeader title={'Simulation'} subtitle={'Test a change'} />
        )}
    />,
    <Route
        exact
        hideJurisdictionSelect
        path={SimulationPath.comparison(':baselineRunId', ':variantRunId')}
        component={SimulationComparison}
        title={({ match }) => (
            <PageTitleHeader
                title={'Simulation'}
                subtitle={`Comparison of #${match.params.baselineRunId} and #${match.params.variantRunId}`}
            />
        )}
    />
];

const runDetailRoute = () => [
    <Route
        exact
        hideJurisdictionSelect
        path={SimulationPath.run(':runId')}
        component={SimulationRunDetail}
        title={({ match }) => (
            <PageTitleHeader
                title={'Simulation'}
                subtitle={`Run #${match.params.runId}`}
            />
        )}
    />
];

/*
  The routes of the simulation: none while it is off, so that a simulation URL is an unknown one, as it is today.
  Whoever may see a screen is decided by SimulationLayout.
*/
export const getSimulationRoutes = () =>
    isSimulationEnabled()
        ? [
              ...runRoutes(),
              ...(isComparisonEnabled() ? comparisonRoutes() : []),
              ...runDetailRoute()
          ]
        : [];
